


import React, { useState, useContext } from 'react';
import { ReactComponent as PencilFill } from "bootstrap-icons/icons/pencil-fill.svg";
import Swal from "sweetalert2";
import { toast } from 'react-toastify';
import AxiosApiCall from '../../api/AxiosApiCall';
import ApiServices from '../../api/ApiServices';
import { handleError } from "../../components/utils/AuthenticationCheck";
import { AuthContext } from '../../AuthProvider/AuthProvider';
import { useNavigate } from "react-router-dom";
const PhysicalProCard = ({ product, setProducts, setAllProducts }) => {
    const [confirmationLoading, setConfirmationLoading] = useState(false);
    const { permissions } = useContext(AuthContext);
    const axios = AxiosApiCall();
    const navigate = useNavigate();

    const handlePhysicalProductUpdate = async (productId, newValue) => {
        const formData = {
            //  id: 1, // API expects discount record ID
            // id: product.id,
            [productId]: newValue,
        };
        // console.log("form data", formData);
        setConfirmationLoading(true);

        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) throw new Error("No access token found.");

            const response = await axios.put(ApiServices.updateAllPhysicalProduct, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            });

            const { status, message } = response.data;
            if (status === 200) {
                toast.success(message);

                // Update current page products
                setProducts((prev) =>
                    prev.map((prod) =>
                        prod.id === productId ? { ...prod, discount: newValue } : prod
                    )
                );

                //  Update full dataset for pagination/filter consistency
                setAllProducts((prev) =>
                    prev.map((prod) =>
                        prod.id === productId ? { ...prod, discount: newValue } : prod
                    )
                );
            } else {
                handleError({ response: { status, data: { message } } });
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setConfirmationLoading(false);
        }
    };

    const handlePhysicalProductUpdateConfirmation = (productId, productName, currentValue) => {
        Swal.fire({
            title: `Update ${productName}`,
            html: `
        <p>Current discount: <strong>${currentValue}%</strong></p>
        <p>Please enter the new discount value:</p>
      `,
            input: "text",
            inputValue: currentValue,
            showCancelButton: true,
            confirmButtonText: "Yes, update it!",
            cancelButtonText: "Cancel",
            inputValidator: (value) => {
                if (!value) {
                    return 'Please enter a value!';
                }
                if (isNaN(value)) {
                    return 'Please enter a valid number!';
                }
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const newValue = result.value;
                if (newValue) {
                    handlePhysicalProductUpdate(product.id, newValue);
                }
            }
        });
    };

    return (
        <div className="p-2 lg:w-1/4 md:w-1/2 w-full">
            <div className="h-full flex items-center border-darkGreen3 border p-4 rounded-lg hover:shadow-md transition">
                <div className="flex-grow">
                    <h2 className="text-darkGreen3 title-font font-medium mb-2">
                        {product.name}
                    </h2>
                    <p className="text-gray-500 mb-3">
                        Discount: <span className="font-semibold">{product.discount}%</span>
                    </p>
                    {permissions.some(permission => permission.name === 'physical.product.edit') && (
                        <button
                            onClick={() => handlePhysicalProductUpdateConfirmation(
                                product.id,
                                product.name,
                                product.discount
                            )}
                            disabled={confirmationLoading}
                            className="text-dash5 border border-gray-300 rounded-md p-2 hover:bg-gray-50 transition"
                        >
                            <PencilFill className="w-4 h-4" />
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PhysicalProCard;
